import type { Message } from '../../types/agent';
import { Timestamp } from './Timestamp';
import { Ticks } from './Ticks';

export function UserBubble({ message }: { message: Message }) {
  return (
    <div
      className="bg-[#D9FDD3] text-[#0A0A0A] text-[15px] md:text-[14px] leading-[1.45] rounded-[18px] shadow-[0_1px_1px_rgba(0,0,0,0.05)] px-3 py-2 max-w-[85%] md:max-w-[65%] wa-bubble-enter ml-auto"
    >
      {message.imageDataUrl && (
        <img
          src={message.imageDataUrl}
          alt="Imagem enviada"
          className="rounded-[12px] max-w-full mb-1 block"
        />
      )}
      {message.pdfName && (
        <div className="flex items-center gap-2 py-1.5 px-2 mb-1 bg-[#0000000a] rounded-[6px]">
          <span aria-hidden="true" className="text-[18px] leading-none">
            📄
          </span>
          <span className="text-[13px] text-[#111B21] break-all">{message.pdfName}</span>
        </div>
      )}
      {message.isAudio && !message.text && (
        <div className="flex items-center gap-2 py-1 text-[#54656F]">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" />
          </svg>
          <span className="text-[13px]">Áudio enviado</span>
        </div>
      )}
      {message.text && <div className="whitespace-pre-wrap">{message.text}</div>}
      <div className="flex justify-end items-center gap-[4px] mt-1">
        <Timestamp epochMs={message.timestamp} />
        <Ticks state={message.deliveryState} />
      </div>
    </div>
  );
}
